(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hn-paket-secici"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hn-paket-secici')) {
    class HnPaketSecici extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.position = this.dataset.optionPosition;
        this.addEventListener('change', (event) => {
          if (!event.target.classList.contains('hn-paket__input')) return;
          this.markSelected(event.target);
          this.forwardToDawn(Number(event.target.dataset.index), event.target.value);
        });
        this.onDawnChange = (event) => {
          const picker = document.getElementById(`variant-selects-${this.sectionId}`);
          if (!picker || !picker.contains(event.target)) return;
          this.syncFromDawn();
        };
        document.addEventListener('change', this.onDawnChange);
        this.varsayilaniSec();
      }

      varsayilaniSec() {
        const sira = Number(this.dataset.varsayilan);
        if (!sira || new URLSearchParams(window.location.search).has('variant')) return;
        const input = this.querySelectorAll('.hn-paket__input')[sira - 1];
        if (!input || input.checked || input.disabled) return;
        input.checked = true;
        this.markSelected(input);
        const gonder = () => setTimeout(() => this.forwardToDawn(Number(input.dataset.index), input.value), 0);
        const bekle = Promise.all([customElements.whenDefined('variant-selects'), customElements.whenDefined('product-info')]);
        if (document.readyState === 'complete') {
          bekle.then(gonder);
        } else {
          window.addEventListener('load', () => bekle.then(gonder), { once: true });
        }
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onDawnChange);
      }

      markSelected(input) {
        this.querySelectorAll('.hn-paket__kart').forEach((card) => {
          card.classList.toggle('is-selected', card.contains(input) && input.checked);
        });
        this.updateOzet(input);
      }

      updateOzet(input) {
        const prop = this.querySelector('.hn-paket__hediye-prop');
        if (prop && input) {
          prop.value = input.dataset.hediyeler || '';
          prop.disabled = !prop.value;
        }
        const ozet = this.querySelector('.hn-paket__ozet');
        if (!ozet || !input) return;
        ozet.hidden = !input.dataset.tasarrufVar;
        ozet.querySelector('.hn-paket__ozet-tutar').textContent = input.dataset.tasarruf;
      }

      forwardToDawn(index, value) {
        const radio = document.getElementById(`${this.sectionId}-${this.position}-${index}`);
        if (radio) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }
        const select = document.getElementById(`Option-${this.sectionId}-${Number(this.position) - 1}`);
        if (select) {
          select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      syncFromDawn() {
        const picker = document.getElementById(`variant-selects-${this.sectionId}`);
        if (!picker) return;
        const checked = picker.querySelector(`input[id^="${this.sectionId}-${this.position}-"]:checked`);
        const select = document.getElementById(`Option-${this.sectionId}-${Number(this.position) - 1}`);
        const value = checked ? checked.value : select ? select.value : null;
        if (value === null) return;
        this.querySelectorAll('.hn-paket__input').forEach((input) => {
          input.checked = input.value === value;
          input.closest('.hn-paket__kart').classList.toggle('is-selected', input.checked);
          if (input.checked) this.updateOzet(input);
        });
      }
    }
    customElements.define('hn-paket-secici', HnPaketSecici);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hn-puan"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (e) => {
    const link = e.target.closest('.hn-puan');
    if (!link) return;
    const hedef = document.getElementById('hn-yorumlar');
    if (!hedef) return;
    e.preventDefault();
    hedef.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hn-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hn-sticky-atc')) {
    class HnStickyAtc extends HTMLElement {
      connectedCallback() {
        const sectionId = this.dataset.sectionId;
        this.mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
        this.priceBox = document.getElementById(`price-${sectionId}`);
        this.button = this.querySelector('.hn-sticky-atc__button');
        this.price = this.querySelector('.hn-sticky-atc__fiyat');
        this.eski = this.querySelector('.hn-sticky-atc__eski');
        this.rozet = this.querySelector('.hn-sticky-atc__rozet');
        this.kazanc = this.querySelector('.hn-sticky-atc__kazanc');
        this.paket = this.querySelector('.hn-sticky-atc__paket');
        this.sayac = this.querySelector('.hn-sticky-atc__sayac');
        if (!this.mainButton) return;

        // Hemen Al varsa çubuk onu tetikler (doğrudan ödeme sayfası); yoksa Sepete ekle.
        this.hedefButon = () =>
          this.mainButton.closest('.product-form__buttons')?.querySelector('.hn-hemen-al__buton') || this.mainButton;

        this.hidden = false;
        this.classList.add('is-gizli');
        // İki ödeme yolu da çubuktan seçilebilir: kart → doğrudan ödeme sayfası, kapıda → kapıda ödeme formu.
        this.kapida = this.querySelector('[data-hn-kapida]');
        this.button.addEventListener('click', () => this.mainButton.click());
        this.kapida.addEventListener('click', () => this.hedefButon().click());

        const izlenen = this.mainButton.closest('.product-form__buttons') || this.mainButton;
        // Asıl butonlar ekranda değilse (henüz gelinmediyse de, geçildiyse de) çubuk görünür;
        // Instagram'dan gelen ziyaretçi ilk ekranda fiyatı ve satın al butonunu görsün.
        this.butonGorunur = true;
        this.kaydirdi = false;
        const guncelle = () => this.classList.toggle('is-gizli', this.butonGorunur || !this.kaydirdi);
        this.observer = new IntersectionObserver(([entry]) => {
          this.butonGorunur = entry.isIntersecting;
          guncelle();
        });
        // Sayfa açılır açılmaz çıkmaz; ziyaretçi ilk ekranı (videoyu) geçince belirir.
        const kaydirma = () => {
          this.kaydirdi = window.scrollY > window.innerHeight * 0.6;
          guncelle();
        };
        window.addEventListener('scroll', kaydirma, { passive: true });
        this.observer.observe(izlenen);

        if (this.priceBox) {
          this.priceObserver = new MutationObserver(() => this.syncState());
          this.priceObserver.observe(this.priceBox, { childList: true, subtree: true, characterData: true });
        }
        this.buttonObserver = new MutationObserver(() => this.syncState());
        this.buttonObserver.observe(this.mainButton, { attributes: true, attributeFilter: ['disabled'] });
        this.syncState();

        this.tikla();
        this.sayacZamani = setInterval(() => this.tikla(), 1000);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.priceObserver?.disconnect();
        this.buttonObserver?.disconnect();
        clearInterval(this.sayacZamani);
      }

      // Türkiye saatiyle gece yarısına kalan süre (üstteki indirim çubuğuyla aynı)
      tikla() {
        const gun = 86400000;
        const kalan = Math.floor((gun - ((Date.now() + 3 * 3600000) % gun)) / 1000);
        const iki = (n) => String(n).padStart(2, '0');
        this.sayac.textContent = `${iki(Math.floor(kalan / 3600))}:${iki(Math.floor((kalan % 3600) / 60))}:${iki(kalan % 60)}`;
      }

      seciliVaryant() {
        const json = document.querySelector(
          `#ProductInfo-${this.dataset.sectionId} [data-selected-variant], [data-selected-variant]`
        );
        try {
          return json ? JSON.parse(json.textContent) : null;
        } catch (e) {
          return null;
        }
      }

      syncState() {
        if (this.priceBox) {
          const current =
            this.priceBox.querySelector('.price--on-sale .price-item--last') ||
            this.priceBox.querySelector('.price__regular .price-item--regular');
          if (current) this.price.textContent = current.textContent.trim();
          const eski = this.priceBox.querySelector('.price--on-sale .price__sale s.price-item--regular');
          this.eski.hidden = !eski;
          if (eski) this.eski.textContent = eski.textContent.trim();
        }

        const v = this.seciliVaryant();
        if (v?.title) this.paket.textContent = v.title;
        // Fiyatlar fiyat kutusundaki data-hn-* özelliklerinden okunur (indirim metafield'dan gelir).
        const kutu = this.priceBox?.querySelector('[data-hn-fiyat]');
        const fiyat = Number(kutu?.dataset.hnFiyat || v?.price || 0);
        const eskiF = Number(kutu?.dataset.hnEski || v?.compare_at_price || 0);
        const indirimli = eskiF > fiyat;
        this.rozet.hidden = !indirimli;
        this.kazanc.hidden = !indirimli;
        if (indirimli) {
          const fark = eskiF - fiyat;
          this.rozet.textContent = `%${Math.floor((fark * 100) / eskiF)} İNDİRİM`;
          const tl = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 }).format(fark / 100);
          this.kazanc.textContent = `${tl} TL kazancınız`;
        }

        this.button.disabled = this.mainButton.disabled;
        this.kapida.disabled = this.mainButton.disabled;
      }
    }
    customElements.define('hn-sticky-atc', HnStickyAtc);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hn-teslimat-tahmini"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hn-teslimat')) {
    class HnTeslimat extends HTMLElement {
      connectedCallback() {
        this.render();
        this.timer = setInterval(() => this.render(), 60000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      isWorkday(date) {
        const day = date.getDay();
        return day !== 0 && day !== 6;
      }

      addWorkdays(start, count) {
        const date = new Date(start);
        let added = 0;
        while (added < count) {
          date.setDate(date.getDate() + 1);
          if (this.isWorkday(date)) added += 1;
        }
        return date;
      }

      render() {
        const now = new Date();
        const cutoff = Number(this.dataset.kesim);
        const min = Number(this.dataset.min);
        const max = Math.max(min, Number(this.dataset.max));
        const shipsToday = this.isWorkday(now) && now.getHours() < cutoff;
        let shipDate = new Date(now);
        if (!shipsToday) {
          shipDate = this.addWorkdays(now, 1);
        }
        const locale = document.documentElement.lang || 'tr';
        const format = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', weekday: 'short' });
        const start = format.format(this.addWorkdays(shipDate, min));
        const end = format.format(this.addWorkdays(shipDate, max));
        const kargo = this.querySelector('.hn-teslimat__kargo');
        if (shipsToday) {
          const deadline = new Date(now);
          deadline.setHours(cutoff, 0, 0, 0);
          const minutes = Math.max(1, Math.round((deadline - now) / 60000));
          const hours = Math.floor(minutes / 60);
          const rest = minutes % 60;
          const sure = hours > 0 ? `${hours} sa ${rest} dk` : `${rest} dk`;
          kargo.textContent = this.dataset.bugun.replace('[sure]', sure);
        } else {
          kargo.textContent = this.dataset.sonraki;
        }
        const tarih = this.querySelector('.hn-teslimat__tarih');
        tarih.textContent =
          min === max
            ? this.dataset.tahmini.replace('[baslangic]', start).replace(' – [bitis]', '').replace('[bitis]', '')
            : this.dataset.tahmini.replace('[baslangic]', start).replace('[bitis]', end);
      }
    }
    customElements.define('hn-teslimat', HnTeslimat);
  }
  } catch(e) { console.error(e); }
})();

})();
